import { useEffect } from 'react';
import { AnimationPanel } from '~/features/animation/AnimationPanel';
import { useExportListener } from '~/features/atlas/actions';
import { useCleanedPipeline } from '~/features/background/useCleanedImageData';
import { useReconcileClips } from '~/features/clips/useReconcileClips';
import { MatteStage } from '~/features/editor/MatteStage';
import { SpriteStage } from '~/features/editor/SpriteStage';
import { useTemplateMatch } from '~/features/frames/referencePoint/useTemplateMatch';
import { attachLiveDetect } from '~/features/pin/livedetect';
import { useHydrateSource } from '~/features/source/hooks';
import { CleanedBitmapProvider } from '~/features/source/SharedBitmapContext';
import { SourceDropZone } from '~/features/source/SourceDropZone';
import { MatteToolbar } from '~/features/toolbar/MatteToolbar';
import { SpriteToolbar } from '~/features/toolbar/SpriteToolbar';
import { StepSwitcher } from '~/features/workflow/StepSwitcher';
import { useAutoCommitOnRehydrate } from '~/features/workflow/useAutoCommitOnRehydrate';
import { useStore } from '~/store';
import { AppShell } from './AppShell';
import { Providers } from './providers';

export function App() {
  useHydrateSource();
  useCleanedPipeline();
  useExportListener();
  useAutoCommitOnRehydrate();
  useReconcileClips();
  useTemplateMatch();
  useEffect(() => attachLiveDetect(), []);
  const step = useStore((s) => s.workflow.step);
  return (
    <Providers>
      <CleanedBitmapProvider>
        <AppShell
          stepNav={<StepSwitcher />}
          toolbar={step === 'matte' ? <MatteToolbar /> : <SpriteToolbar />}
          canvas={
            <div className="flex h-full">
              <SourceDropZone>{step === 'matte' ? <MatteStage /> : <SpriteStage />}</SourceDropZone>
              {step === 'sprite' && <AnimationPanel />}
            </div>
          }
        />
      </CleanedBitmapProvider>
    </Providers>
  );
}
